export enum VirtualGroupTypeEnumerator {
  ELECTIVE = 1,
  TRAIL = 2,
}